
    import Vue from 'vue';
    import LayoutDefault from '@/apps/shared/components/LayoutDefault.vue';
    import LayoutRetiro from '@/apps/shared/components/LayoutRetiro.vue';
    import serviceFail from '@/apps/shared/components/serviceFail.vue';
    import chatbot from '@/apps/shared/components/chatbot.vue';
    import { applyLayoutStyle, LayoutType } from '@/apps/shared/services/layoutService';

    export default Vue.extend({
        name: 'App',
        components: {
            LayoutDefault,
            LayoutRetiro,
            serviceFail,
            chatbot
        },
        data() {
            return {
                showServiceFail: false
            };
        },
        computed: {
            resolvedLayout(): string {
                const metaLayout = this.$route.meta.layout;
                if (metaLayout === 'retiro') return 'LayoutRetiro';
                return 'LayoutDefault';
            }
        },
        watch: {
            '$route'(to) {
                this.applyLayoutFromRoute(to.meta.layout);
            }
        },
        created() {
            this.applyLayoutFromRoute(this.$route.meta.layout);
            window.addEventListener('beforeunload', (e) => {
                if (sessionStorage.getItem('ExitOrContinueModal') === 'true') {
                    e.preventDefault();
                    (e || window.event).returnValue = '';
                }
            });
        },
        methods: {
            applyLayoutFromRoute(layoutMeta: string) {
                const layoutType = layoutMeta === 'retiro' ? LayoutType.Retiro : LayoutType.Default;
                applyLayoutStyle(layoutType);
            }
        }
    });
